import { AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Fetch } from "../../shared/Fetch";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

interface ICluse {
  id?: number;
  special_Clause?: string;
  // parent_ID?: number | null,
}

const schema = yup.object({
  special_Clause: yup.string().trim().required("Clause Name is required"),
});

export const ClauseMaster = () => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[]; loading: boolean });
  const [openModal, setOpenModal] = useState({ open: false, singleData: {} } as { open: boolean; singleData: any });
  const [openSubModal, setOpenSubModal] = useState({ open: false, singleData: {} } as { open: boolean; singleData: any });

  const toast = useRef<any>(null);

  const openNew = (data: any) => {
    setOpenModal({ open: true, singleData: data });
  };
  const openSubNew = (data: any) => {
    setOpenSubModal({ open: true, singleData: data });
  };

  const leftToolbarTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => openNew(rowData)} />
        </div>
      </React.Fragment>
    );
  };

  const onRemoveSubClause = async (data: ICluse) => {
    const response = await Fetch("Dropdown/removeClause", "DELETE", null, `clauseID=${data.id}`, toast);
    if (response) {
      toast.current.show({ severity: "success", detail: "Deleted Successfully", life: 3000 });
      loadTableData();
    }
  };

  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to Delete Clause`,
      header: "Confirm ",
      icon: "pi pi-exclamation-triangle",
      // defaultFocus: 'reject',
      acceptClassName: "p-button-danger",
      accept: () => onRemoveSubClause(rowData),
      reject: () => () => {},
    });
  };

  const Actions = (rowData: any) => {
    return (
      <div className="my-2">
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded  p-button-text"
          tooltip="Edit Clause"
          onClick={() => {
            openNew(rowData);
          }}
        />
        <Button
          icon="pi pi-plus"
          className="p-button-rounded  p-button-text"
          tooltip="Add Sub Clause"
          onClick={() => {
            openSubNew(rowData);
          }}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-danger"
          tooltip="Delete Clause"
          onClick={() => {
            confirmDelete(rowData);
          }}
        />
      </div>
    );
  };

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Dropdown/getClause", "GET", null, null, toast);
    if (response) {
      const data = await response.json();
      setTableData({ tableData: data, loading: false });
    } else setTableData({ tableData: tableData.tableData, loading: false });
  };

  const onHideModal = () => {
    setOpenModal({ open: false, singleData: {} });
    loadTableData();
  };
  const onHideModal2 = () => {
    setOpenSubModal({ open: false, singleData: {} });
    // loadTableData();
  };

  useEffect(() => {
    loadTableData();
  }, []);

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
      <DataTable className="mt-2" style={{ border: "1px solid rgba(105,105,105,0.5)", borderTopWidth: "0" }} size="small" value={tableData.tableData} header="Clause List" showGridlines stripedRows loading={tableData.loading}>
        <Column field="special_Clause" header="Clause Name" />
        <Column field="" header="Action" body={Actions} />
      </DataTable>
      <OpenClauseAddingUpdatingModal open={openModal.open} singleData={openModal.singleData} onClose={onHideModal} toast={toast} />
      <OpenSubClauseAddingUpdatingModal open={openSubModal.open} singleData={openSubModal.singleData} onClose={onHideModal2} toast={toast} />
      <Toast ref={toast} />
      <ConfirmDialog />
    </>
  );
};

interface IProps2 {
  open: boolean;
  singleData: ICluse;
  onClose: () => void;
  toast: any;
}

const OpenClauseAddingUpdatingModal = (props: IProps2) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<ICluse>({
    resolver: yupResolver(schema),
    defaultValues: {},
    shouldFocusError: false,
  });

  const onSubmit = async (data: ICluse) => {
    setLoading(true);
    let newData = { ...data };
    // newData.parent_ID = null;
    const response = await Fetch("Dropdown/" + (newData.id !== null && newData.id !== undefined && newData.id > 0 ? "updateClause" : "addClause"), newData.id !== null && newData.id !== undefined && newData.id > 0 ? "PUT" : "POST", newData, null, props.toast);
    if (response) {
      setLoading(false);
      props.toast.current.show({ severity: "success", detail: "Added Successfully", life: 3000 });
      onHide();
    } else setLoading(false);
  };

  const onHide = () => {
    reset({ special_Clause: "" });
    props.onClose();
  };

  useEffect(() => {
    if (props.open && props.singleData.id) {
      reset({ ...props.singleData });
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "20vw" }} header="Add/Edit Clause" modal className="p-fluid" onHide={onHide}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
        <JVInput column={1} label="Clause Name" control={control} name="special_Clause" error={errors.special_Clause?.message} placeholder="Enter Clause Name" />
        <div className="field col-12 md:col-12">
          <label htmlFor="">&nbsp;</label>
          <div className="w-full flex flex-row-reverse">
            <Button loading={loading} label="SAVE" type="submit"></Button>
          </div>
        </div>
      </form>
    </Dialog>
  );
};

const OpenSubClauseAddingUpdatingModal = (props: IProps2) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[]; loading: boolean });
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<ICluse>({
    resolver: yupResolver(schema),
    defaultValues: {},
    shouldFocusError: false,
  });

  const onSubmit = async (data: ICluse) => {
    setLoading(true);
    let newData = { ...data };
    // newData.parent_ID = props.singleData.id;

    const response = await Fetch("Dropdown/" + (newData.id !== null && newData.id !== undefined && newData.id > 0 ? "updateClause" : "addClause"), newData.id !== null && newData.id !== undefined && newData.id > 0 ? "PUT" : "POST", newData, null, props.toast);
    if (response) {
      setLoading(false);
      props.toast.current.show({ severity: "success", detail: "Added Successfully", life: 3000 });
      reset({ special_Clause: "", id: 0 });
      loadTableData();
    } else setLoading(false);
  };

  const onRemoveSubClause = async (data: ICluse) => {
    const response = await Fetch("Dropdown/removeClause", "DELETE", null, `clauseID=${data.id}`, props.toast);
    if (response) {
      props.toast.current.show({ severity: "success", detail: "Deleted Successfully", life: 3000 });
      loadTableData();
    }
  };

  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to Delete Sub Clause`,
      header: "Confirm ",
      icon: "pi pi-exclamation-triangle",
      // defaultFocus: 'reject',
      acceptClassName: "p-button-danger",
      accept: () => onRemoveSubClause(rowData),
      reject: () => () => {},
    });
  };

  const onHide = () => {
    props.onClose();
  };

  const Actions = (rowData: any) => {
    return (
      <div className="my-2">
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded  p-button-text"
          tooltip="Edit Sub Clause"
          onClick={() => {
            reset(rowData);
          }}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-danger"
          tooltip="Delete Sub Clause"
          onClick={() => {
            confirmDelete(rowData);
          }}
        />
      </div>
    );
  };

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Dropdown/getSubClause", "GET", null, `clauseID=${props.singleData.id}`, props.toast);
    if (response) {
      const data = await response.json();
      setTableData({ tableData: data, loading: false });
    } else setTableData({ tableData: tableData.tableData, loading: false });
  };

  useEffect(() => {
    if (props.open && props.singleData.id) {
      loadTableData();
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "40vw" }} header="Add/Edit Sub Clause" modal className="p-fluid" onHide={onHide}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
        <JVInput column={1} label="Clause Name" control={control} name="special_Clause" error={errors.special_Clause?.message} placeholder="Enter Clause Name" />
        <div className="field col-12 md:col-12">
          <div className="w-full flex flex-row-reverse">
            <Button loading={loading} label="SAVE" type="submit"></Button>
          </div>
        </div>
      </form>
      <DataTable className="mt-2" style={{ border: "1px solid rgba(105,105,105,0.5)", borderTopWidth: "0" }} size="small" value={tableData.tableData} header="Clause List" showGridlines stripedRows loading={tableData.loading}>
        <Column field="special_Clause" header="Clause Name" />
        <Column field="" header="Action" body={Actions} />
      </DataTable>
      <ConfirmDialog />
    </Dialog>
  );
};
